import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Grupo, Parametros, Subgrupo } from '../models/parametros.model';
import { ConfigService } from '../core/config/config.service';


@Injectable({
  providedIn: 'root'
})
export class ParametrosService {


  private readonly configService = inject(ConfigService);
    private get loginUrl(): string {
      const baseUrl = this.configService.settings()?.apiUrl;
      return `${baseUrl}/parametros`;
    }


  constructor(private http: HttpClient) { }

  getGrupos(): Observable<Grupo[]> {
    return this.http.get<Grupo[]>(this.loginUrl + '/despesa-grupos');
  }

  

  getGrupo(id: number): Observable<Grupo> {
    return this.http.get<Grupo>(this.loginUrl + '/despesa-grupos/'+ id);
  }

  createGrupo(grupo: Grupo): Observable<Grupo> {
    return this.http.post<Grupo>(this.loginUrl + '/despesa-grupos', grupo);
  }

  updateGrupo(grupo: Grupo): Observable<Grupo> {
    return this.http.put<Grupo>(this.loginUrl + '/despesa-grupos', grupo);
  }

  deleteGrupo(id: number): Observable<void> {
    return this.http.delete<void>(this.loginUrl + '/despesa-grupos' + '/' + id);
  }

  getSubgrupos(): Observable<Subgrupo[]> {
    return this.http.get<Subgrupo[]>(this.loginUrl + '/despesa-subgrupos');
  }

  getSubgrupo(id: number): Observable<Subgrupo> {
    return this.http.get<Subgrupo>(this.loginUrl + '/despesa-subgrupos' + id);
  }

  createSubgrupo(subgrupo: Subgrupo): Observable<Subgrupo> {
    return this.http.post<Subgrupo>(this.loginUrl + '/despesa-subgrupos', subgrupo);
  }

  updateSubgrupo(subgrupo: Subgrupo): Observable<Subgrupo> {
    return this.http.put<Subgrupo>(this.loginUrl + '/despesa-subgrupos', subgrupo);
  }

  deleteSubgrupo(id: number): Observable<void> {
    return this.http.delete<void>(this.loginUrl + '/despesa-subgrupos'+ '/' + id);
  }

  getParametrosByCategorias(categorias: string[]): Observable<Parametros[]> {
    let params = new HttpParams();

    categorias.forEach((categoria) => {
      params = params.append('categorias', categoria);
    });

    return this.http.get<Parametros[]>(this.loginUrl + '/parametros/categorias', { params });
  }

  getParametros(): Observable<Parametros[]> {
    return this.http.get<Parametros[]>(this.loginUrl + '/parametros');
  }

  getParametroById(id: number): Observable<Parametros> {
    return this.http.get<Parametros>(this.loginUrl + '/parametros/' + id);
  }

  createParametro(parametro: Parametros): Observable<Parametros> {
    return this.http.post<Parametros>(this.loginUrl + '/parametros', parametro);
  }

  updateParametro(parametro: Parametros): Observable<Parametros> {
    return this.http.put<Parametros>(this.loginUrl + '/parametros', parametro);
  }
}
